'use strict';

angular.module('app.newInfluencers', [])

.controller('AdminNewInfluencersCtrl', function ($scope, $modal, $http, $rootScope, localStorageService, $window, adminService) {
    $scope.loaded = false;
    $scope.InfluencersAll = [];
    $scope.currentPage = 1;
    $scope.pageSize = 25;
    $scope.fieldName = null;
    $scope.order = true;
    $scope.tempOrder = true; 
    $scope.unapprovedId = null;
    $scope.newStatusId = null;
    var searchInfluencerURL = $rootScope.apiUrl + 'admin/searchInfluencers';
    $scope.getNumberOfInfluencersURL = $rootScope.apiUrl + 'admin/getNumberOfInfluencers';
    var enableWatch = false;

    //PreLoadData to load all unapproved influencer
    $scope.preLoadData = function(page){
        $scope.renderPlatform();
        $scope.currentPage = page;
        var getUnapprovedIdUrl = $rootScope.apiUrl + 'admin/getUnapprovedId';
        $http.get(getUnapprovedIdUrl, {loader: false})
            .success(function(responseApproved){
                $scope.unapprovedId = {
                    id: responseApproved.data.id
                };
                var getNewStatusIdUrl = $rootScope.apiUrl + 'admin/getNewStatusId';
                $http.get(getNewStatusIdUrl, {loader: false})
                    .success(function(responseNewStatus){
                        $scope.newStatusId = [
                            {id: responseNewStatus.data.id}
                        ];
                        var data = {
                            selectedPlatform:   null,
                            selectedApproval:   $scope.unapprovedId,
                            selectedStatus:     $scope.newStatusId,
                            pageNo:             $scope.currentPage,
                            sortByColumn:       $scope.fieldName,
                            sortType:           $scope.order
                        };

                       $scope.sendHttpPOST(data, searchInfluencerURL);
                    });
            });        
    };

    $scope.sendHttpPOST = function(data, url){
        var req = {
            url: url,
            method: 'POST',
            data: JSON.stringify(data)
        };
        
        $http(req).success(function (response) {
            $scope.influencer = response.data;     
            $scope.networkOnResponse();
            enableWatch = true;      
        }) .error(function (response) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = response.message;
        });

        var request = {
            url: $scope.getNumberOfInfluencersURL,
            method: 'POST',
            data: JSON.stringify(data)
        }       

        $http(request).success(function (responseNumberOfInfluencers) {
            $scope.number = responseNumberOfInfluencers.totalRow;  
            $scope.pagination();
        }) .error(function (responseNumberOfInfluencers) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = responseNumberOfInfluencers.message;
        });       
    };    

    $scope.networkOnResponse = function(dataNetwork){
        angular.forEach(dataNetwork, function(item){
            if (item.network != null) {
                var getNetworkByIdUrl = $rootScope.apiUrl + 'network/getNetworkById/' + item.network.id;
                $http.get(getNetworkByIdUrl, {loader: false})
                    .success(function(responseGetNetworkById){
                        item.network.name = responseGetNetworkById.data.name;     
                })
            }
        });
    };

    $scope.pagination = function(){
    	$scope.pages = adminService.pagination($scope.number, $scope.pageSize);
    };

    //Traverse through pages
    $scope.updatePage = function(val){
        $scope.currentPage = val;

        $scope.platforms.forEach(function (val) {
        if (val.ticked === true) {
                $scope.selectedPlatform = val;
            }    
        });

        var dataUpdatePage = {
            selectedPlatform:   $scope.selectedPlatform.id,
			selectedApproval:   $scope.unapprovedId,
			selectedStatus:     $scope.newStatusId,
            pageNo:             val,
            sortByColumn:       $scope.fieldName,
            sortType:           $scope.order
       };

       $scope.sendHttpPOST(dataUpdatePage, searchInfluencerURL);
    };    

    $scope.renderPlatform = function(){
        var getPlatformUrl = $rootScope.apiUrl + 'admin/getPlatform';
        $http.get(getPlatformUrl, {loader: false})
            .success(function(responseGetPlatform){
                $scope.platforms = responseGetPlatform.data;
                var object = {
                    id: null,
                    name: "All Platforms",
                    description: null
                };
                $scope.platforms.splice(0,0, object);
            });        
    }
            
    $scope.preLoadData(1);

    $scope.PlatformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.influencerDetails = function (id, infIndex) {
        var influencerDetailsCurrentPage = $scope.currentPage;
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/influencers-new-influencer-details.html?app_v=deployDate',
            controller: 'NewInfluencerDetailsCtrl'
        });
        modalInstance.result.then(function () {
          $scope.preLoadData(influencerDetailsCurrentPage);
        }, function (reason) {
            if(reason = 'escape key press'){
                $scope.preLoadData(influencerDetailsCurrentPage);
            }
        });
        $scope.modalInstance = modalInstance;
        $scope.id = id;
        $scope.newInfluencerIndex = infIndex;
        $scope.flag = true;
    };

    $scope.newInfluencerModalHandler = function () {
        var newInfluencerCurrentPage = $scope.currentPage;
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewInfluencerModal.html?app_v=deployDate',
            controller: 'AddNewInfluencerCtrl'
        });

        $scope.modalInstance = modalInstance;
        $scope.flag = true;
        $scope.influencers = false;
        modalInstance.result.then(function () {
          $scope.preLoadData(newInfluencerCurrentPage);
        }, function () {
          
        });
    };

    $scope.goToURL = function(selectedChannel, $event) {
        var platformDomain = null;
        var channelDomain = null;
        var getDomainUrl = $rootScope.apiUrl + 'admin/getPlarformDomainUrl/' + selectedChannel.channel_id;
        $http.get(getDomainUrl, {loader: false})
            .success(function(responseGetDomain){
                platformDomain = responseGetDomain.data.domain;   
                channelDomain = responseGetDomain.channel.handle;  
                if(responseGetDomain.channel.isLinked == 1){
                    if(responseGetDomain.channel.platform_id == 6) {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + responseGetDomain.channel.youtubeType.toLowerCase() + '/' + selectedChannel.handle, '_blank');
                    } else {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + selectedChannel.handle, '_blank');
                    }
                }
            });
        $event.stopPropagation();                           
    };

    $scope.searchByPlatform = function(){
        var dataSearchByPlatform = {
            selectedPlatform:   $scope.selectedPlatform.id,
            selectedApproval:   $scope.unapprovedId,
            selectedStatus:     $scope.newStatusId,
            pageNo:             1,
            sortByColumn:       $scope.fieldName,
            sortType:           $scope.order
        };

        $scope.currentPage = 1;

        $scope.sendHttpPOST(dataSearchByPlatform, searchInfluencerURL);        
    };        

    $scope.$watch('selectedPlatform', function(newValue, oldValue){
        if(enableWatch && newValue !== oldValue && newValue !== undefined && newValue.length > 0)
        {
            $scope.selectedPlatform = newValue[0];
            $scope.searchByPlatform();
        }
    });

})